// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"UploadOfferDocuments_modal_title__sdIKB"};